import { AxiosResponse } from "axios";
import axiosInstance from "../../../interceptors/axiosInstance";
import { beneficio, destino, ejecutivo, finalidad, operacion, origen, tipoProducto, tipoSubsidio } from "../models/operacion";
import { ListResponseDto } from "../../../dtos/ListResponseDto";

const getTipoProducto = async () => {
    const response: AxiosResponse<ListResponseDto<tipoProducto>> = await axiosInstance.get(`siscred-api-mutuo/v1/operacion/obtener-tipo-producto`);
    return response;
};

const getDestinos = async () => {
    const response: AxiosResponse<ListResponseDto<destino>> = await axiosInstance.get(`siscred-api-mutuo/v1/operacion/obtener-destino`);
    return response;
};

const getEjecutivos = async () => {
    const response: AxiosResponse<ListResponseDto<ejecutivo>> = await axiosInstance.get(`siscred-api-mutuo/v1/operacion/obtener-ejecutivo`);
    return response;
};

const getOrigenes = async () => {
    const response: AxiosResponse<ListResponseDto<origen>> = await axiosInstance.get(`siscred-api-mutuo/v1/operacion/obtener-origen`);
    return response;
};

const getFinalidades = async () => {
    const response: AxiosResponse<ListResponseDto<finalidad>> = await axiosInstance.get(`siscred-api-mutuo/v1/operacion/obtener-finalidad`);
    return response;
};

const getTipoSubsidio = async () => {
    const response: AxiosResponse<ListResponseDto<tipoSubsidio>> = await axiosInstance.get(`siscred-api-mutuo/v1/operacion/obtener-tipo-subsidio`);
    return response;
};

const getBeneficios = async () => {
    const response: AxiosResponse<ListResponseDto<beneficio>> = await axiosInstance.get(`siscred-api-mutuo/v1/operacion/obtener-beneficio`);
    return response;
};

const getOperacion = async (idMutuo: number) => {

    const axiosResponse: Promise<AxiosResponse> = axiosInstance.get(`siscred-api-mutuo/v1/operacion/obtener-operacion`, {
        params: {
            idMutuo: idMutuo
        }
    });

    return axiosResponse;
}

const putOperacion = async (operacion: operacion) => {
    const response: AxiosResponse = await axiosInstance.put(`siscred-api-mutuo/v1/operacion/actualizar-operacion/${operacion.idMutuo}`, operacion);
    return response;
}

const copyOperacion = async (idSolicitud: string) => {
    const response: AxiosResponse = await axiosInstance.post(`siscred-api-mutuo/v1/operacion/copiar-operacion`, {
        idSolicitud: Number(idSolicitud)
    });
    return response;
}

export {
    getTipoProducto,
    getDestinos,
    getEjecutivos,
    getOrigenes,
    getFinalidades,
    getTipoSubsidio,
    getBeneficios,
    getOperacion,
    putOperacion,
    copyOperacion
}